import MemoryMateConfiguratorTemplate from './MemoryMateConfiguratorTemplate';

export default MemoryMateConfiguratorTemplate;
